export const fabricTop100Whitelist = [
  // Core
  "fabric_capacity",
  "fabric_workspace",
  "fabric_folder",
  "fabric_deployment_pipeline",
  // Data
  "fabric_lakehouse",
  "fabric_warehouse",
  "fabric_sql_database",
  "fabric_onelake",
  // Engineering
  "fabric_pipeline",
  "fabric_dataflow",
  "fabric_notebook",
  // Analytics & AI
  "fabric_semantic_model",
  "fabric_report",
  "fabric_ml_model",
  "fabric_data_agent",
  // Real-time Intelligence
  "fabric_eventstream",
  "fabric_eventhouse",
  "fabric_kql_database",
  // Governance
  "azurerm_purview_account",
  "azurerm_policy_assignment",
  "fabric_domain",
] as const;
